import gql from 'graphql-tag'

export const GET_SUPPORT_SOURCES = gql`
  query supportSources{
    supportSources: SupportSources{
      id
      name
    }
  }
`
export const GET_SUPPORT_CATEGORY = gql`
  query supportCategory{
    supportCategory: SupportCategory{
      id
      name
    }
  }
`
export const GET_SUPPORT_STATUSES = gql`
  query supportStatuses{
    supportStatuses: SupportStatuses(order_by: {sequence: asc}){
      id
      name
    }
  }
`
export const GET_SUPPORT_ASSIGNEE = gql`
  query supportAssignee($userTypeId: [uuid!]){
    supportAssignee: Users(where:{userTypeId:{_in:$userTypeId}}){
      id
      name
      UserType{id name}
    }
  }
`
export const GET_SUPPORTS = gql`
  query ($filter: String!, $createdBy: uuid!){
    Supports(where: {createdBy: {_eq: $createdBy}, _or: [{serialNo: {_ilike: $filter}},{title: {_ilike: $filter}},{AssignTo: {name: {_ilike: $filter}}},
                {Customer: {name:{_ilike: $filter}}},{SupportPlan: {name: {_ilike: $filter}}},{Product: {name: {_ilike: $filter}}}]},
                 order_by: {created_at: desc}){
      id
      title
      level
      priority
      supportNo
      AssignTo { id name }
      Status { id name }
      Product { id name }
      Customer { id name }
      SupportPlan { id name }
      serialNo
      isSupportPlanActive
      created_at
    }
  }
`
export const GET_PRODUCT_SUPPORT_PLANS = gql`
query{
  SupportPlans{
    id
    name
    duration
  }
}`
